import { Controller } from "@hotwired/stimulus";
import { internalApiClient } from "../src/libs/axios/internalApiClient";
import { Modal } from "bootstrap";

export default class extends Controller {
  static targets = ["statusName"];
  static values = { status: String };

  declare readonly statusNameTarget: HTMLElement;
  declare statusValue: string;

  private modal: Modal | null = null;

  connect() {
    // モーダルを初期化
    this.modal = new Modal(this.element);

    // モーダルが表示される前のイベントリスナー
    this.element.addEventListener("show.bs.modal", this.handleModalShow.bind(this));
  }

  // モーダル表示時のステータス設定
  handleModalShow(event: any) {
    const button = event.relatedTarget;
    // data-statusをStimulusのvalueに設定
    this.statusValue = button.getAttribute("data-status");

    // ステータス名をモーダルに表示
    let statusName = "";
    if (this.statusValue === "reviewing") {
      statusName = "選考中";
    } else if (this.statusValue === "hired") {
      statusName = "採用";
    } else if (this.statusValue === "rejected") {
      statusName = "不採用";
    }
    this.statusNameTarget.textContent = statusName;
  }

  // 一括ステータス更新
  async updateStatus() {
    // チェックされてます応募のチェックボックスを取得
    const checkedEntries = document.querySelectorAll<HTMLInputElement>(".js_applicant_check:checked");

    // チェックされていない場合はモーダルを閉じる
    if (checkedEntries.length === 0) {
      return;
    }

    // 応募IDを収集
    const entryKeys: string[] = [];

    // チェックされた各応募からIDを取得
    checkedEntries.forEach((checkbox) => {
      const entryBlock = checkbox.closest(".applicant_block");
      if (!entryBlock) return;

      const statusSelect = entryBlock.querySelector<HTMLSelectElement>("[data-job-entry-status-entry-key]");
      if (!statusSelect) return;

      // チェックがついた応募のIDを取得し、配列に格納
      const entryKey = statusSelect.getAttribute("data-job-entry-status-entry-key");
      if (entryKey) {
        entryKeys.push(entryKey);
      }
    });

    // チェックがついているIDが1件も取得できなかった場合はモーダルを閉じる
    if (entryKeys.length === 0) {
      return;
    }

    try {
      // API呼び出し - APIコントローラ側でフラッシュメッセージをセットしている
      await internalApiClient.patch("/employer/job_entries/bulk_update_hiring_status", {
        entry_keys: entryKeys,
        hiring_status: this.statusValue,
      });

      // pageパラメータがある場合は削除してリロード
      const url = new URL(window.location.href);
      if (url.searchParams.has("page")) {
        url.searchParams.delete("page");
        window.location.href = url.toString();
      } else {
        window.location.reload();
      }
    } catch (error) {
      console.error(error);
    }
  }
}
